const toText = (value) => String(value || '').trim();
export function buildComposerDraftRoundKey({
  activeSessionId,
  currentInput,
}) {
  const sessionPart = toText(activeSessionId) || 'draft';
  const inputPart = toText(currentInput);
  return `${sessionPart}:${inputPart}`;
}


/**
 * Cards supply draft text only; execution metadata never crosses this boundary.
 * @returns {{ kind: 'noop' } | { kind: 'prefill'; content: string }}
 */
export function resolveComposerActionIntent(choice) {
  const content = choice?.prompt ?? choice?.text;
  if (typeof content !== 'string' || !content.trim()) return { kind: 'noop' };
  return { kind: 'prefill', content };
}
